<template>
  <layout-main-inner title="快检实验室">
    <!-- <el-button
      v-if="permission.LVL2"
      slot="action"
      type="primary"
      @click="additem">
      新增实验室
    </el-button> -->
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.labName"
          clearable
          placeholder="请输入实验室名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          min-width="160"
          label="实验室名称"
          prop="labName">
        </el-table-column>
        <el-table-column
          label="地址"
          min-width="220"
          prop="address"
        ></el-table-column>
        <el-table-column
          label="联系人"
          prop="contactPerson"
          width="100"
        ></el-table-column>
        <el-table-column
          label="手机号"
          prop="contactPhone"
          width="100"
        ></el-table-column>
        <el-table-column
          label="邮箱"
          prop="contactEmail"
          width="120"
        ></el-table-column>
        <el-table-column
          v-if="!permission.LVL2"
          label="所属机构"
          prop="sgsName"
          min-width="120"
        ></el-table-column>
        <el-table-column
          v-if="permission.LVL2"
          label="操作"
          width="80">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">
              编辑
            </el-button>
            <!-- <el-button
              type="danger"
              @click="deleteitem(row)">
              删除
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <edit-lab-modal
      ref="lab"
      :callback="
        () => {
          getlist();
        }
      "
    />
  </layout-main-inner>
</template>
<script>

import { mapState } from 'vuex'
import EditLabModal from './edit-lab-modal.vue'
export default {
  name: 'LabsIndex',
  components: { EditLabModal },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        labName: '',
        labType: 2
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      this.$refs.lab.update({
        labId: row.labId,
        labName: row.labName,
        contactPerson: row.contactPerson,
        contactPhone: row.contactPhone,
        contactEmail: row.contactEmail,
        address: row.address
      })
    },
    additem() {
      this.$refs.lab.add(this.userInfo.orgId)
    },
    deleteitem(row) {
      this.$confirm('您确定删除该实验室?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletelab', {
          payload: {
            labId: row.labId
          },
          success: () => {
            this.loading = false
            this.handleCurrentChange(1)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getlabs', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
